import { render, staticRenderFns } from "./ResultFormAe.vue?vue&type=template&id=7968bd3c&scoped=true&"
import script from "./ResultFormAe.vue?vue&type=script&lang=js&"
export * from "./ResultFormAe.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormAe.vue?vue&type=style&index=0&id=7968bd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968bd3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7968bd3c')) {
      api.createRecord('7968bd3c', component.options)
    } else {
      api.reload('7968bd3c', component.options)
    }
    module.hot.accept("./ResultFormAe.vue?vue&type=template&id=7968bd3c&scoped=true&", function () {
      api.rerender('7968bd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormAe.vue"
export default component.exports